export const categories = {
  SELF_ONBOARDING: 'self_onboarding'
};

export const pageViews = {
  AMENITY_REVAMP_SCREEN: 'amenity_revamp_screen',
  PROPERTY_LOCATION_SCREEN: 'property_location_screen',
  PROPERTY_TYPE: 'property_type',
  PROPERTY_SUB_TYPE: 'property_sub_type',
  OTA_SCREEN: 'ota_screen',
  LOGIN_PAGE_PROPERTY_ONBOARD: 'login_page_propertyOnboard',
  PROPERTY_INFO: 'property_info'
};

export const events = {
  SELF_ONBOARDING_FOOTER: 'self_onboarding_footer',
  SELF_ONBOARDING_DASHBOARD: 'self_onboarding_dashboard',
  SELF_ONBOARDING_CHECKLIST: 'self_onboarding_checklist',
  SELF_ONBOARDING_KYC: 'self_onboarding_kyc',
  SELF_ONBOARDING_ROOMS: 'self_onboarding_rooms',
  SELF_ONBOARDING_IMAGES: 'self_onboarding_images',
  SELF_ONBOARDING_PHOTO_TIPS: 'self_onboarding_photo_tips',
  SELF_ONBOARDING_FACILITIES: 'self_onboarding_facilities',
  SELF_ONBOARDING_BASIC_INFO: 'self_onboarding_basic_info',
  SELF_ONBOARDING_CREATE_LEAD: 'self_onboarding_create_lead',
  SELF_ONBOARDING_CREATE_LEAD_V2: 'self_onboarding_create_lead_v2',
  SELF_ONBOARDING_LOGIN: 'self_onboarding_login',
  SELF_ONBOARDING_LOGIN_V2: 'self_onboarding_login_v2',
  SELF_ONBOARDING_LOCATION_DETAILS: 'self_onboarding_location_details',
  SELF_ONBOARDING_CONFIRM_ADDRESS: 'self_onboarding_confirm_address',
  SELF_ONBOARDING_CONFIRM_ADDRESS_COLD_LEAD: 'self_onboarding_confirm_address_cold_lead',
  SELF_ONBOARDING_KYC_V2: 'self_onboarding_kyc_v2',
  SELF_ONBOARDING_TOS_V2: 'self_onboarding_tos_v2',
  SELF_ONBOARDING_PROPERTY_REVIEW: 'self_onboarding_property_review',
  SELF_ONBOARDING_CONGRATS: 'self_onboarding_congrats',
  SELF_ONBOARDING_REFERRAL: 'self_onboarding_referral'
};

export const moEvents = {
  ADD_KYC: 'add_kyc',
  SUBMIT_KYC: 'submit_kyc',
  KYC_CONTACT_PAGE_VIEW: 'kyc_contact_page_view',
  KYC_STATUS: 'kyc_status',
  ADD_PHOTOS: 'add_photos',
  SUBMIT_PHOTOS: 'submit_photos',
  PHOTOS_STATUS: 'photos_status',
  ADD_FACILITIES: 'add_facilities',
  SUBMIT_FACILITIES: 'submit_facilities',
  FACILITIES_STATUS: 'facilities_status',
  ADD_ROOMS: 'add_rooms',
  SUBMIT_ROOMS: 'submit_rooms',
  ROOMS_STATUS: 'rooms_status',
  ADD_BASIC_INFO: 'add_basic_info',
  SUBMIT_BASIC_INFO: 'submit_basic_info',
  BASIC_INFO_STATUS: 'basic_info_status',
  PROPERTY_INFO_NEXT_CLICKED: 'property_info_next_clicked',
  PROPERTY_INFO_SCREEN_VISITED: 'property_info_screen_visited',
  PROPERTY_DETAIL_NEXT_CLICKED: 'property_detail_next_clicked',
  PROPERTY_DETAIL_SCREEN_VISITED: 'property_detail_screen_visited',
  CONTRACT_SCREEN_VISITED: 'contract_screen_visited',
  AGREE_CONTRACT: 'agree_contract',
  PUBLISH_PROPERTY_CLICKED: 'publish_property_clicked',
  SUBMIT_PROPERTY_CLICKED: 'submit_property_clicked',
  CHECKLIST_SCREEN_VISITED: 'checklist_screen_visited',
  PROPERTY_DASHBOARD_SCREEN_VISITED: 'property_dashboard_screen_visited',
  LOGIN_SUCCESSFUL: 'login_successful',
  PHOTOS_SCREEN_VIEWED: 'photos_screen_viewed'
};

export const eventActions = {
  GALLERY_UPLOAD_PHOTOS_CTA_CLICKED: 'gallery_upload_photos_cta_clicked',
  GALLERY_IMAGE_DELETE_CTA_CLICKED: 'gallery_image_delete_cta_clicked',
  VIEW_SAMPLE_IMAGES_CTA_CLICKED: 'view_sample_images_cta_clicked',
  BACK_CTA_CLICKED: 'back_cta_clicked',
  OPEN_TIPS_VIDEO_LINK_CLICKED: 'open_tips_video_link_clicked',
  SUBMIT_CTA_CLICKED: 'submit_cta_clicked',
  TIPS_BULB_CLICKED: 'tips_bulb_clicked',
  IMAGE_PREVIEW_CLICKED: 'image_preview_clicked',
  DELETE_UNTAGGED_IMAGE_CLICKED: 'delete_untagged_image_clicked',
  RECATEGORIZE_FILTER_APPLIED: 'recatogorize_filter_applied',
  REJECTED_IMAGE_DELETE_CTA_CLICKED: 'rejected_image_delete_cta_clicked',
  REJECTED_IMAGES_BANNER_VISIBLE: 'rejected_images_banner_visible',
  VIEW_IS_THIS_YOUR_HOTEL: 'view_is_this_your_hotel',
  VERIFY_PROPERTY_NEXT_BUTTON_CLICKED: 'verify_property_next_button_clicked',
  VERIFY_PROPERTY_SKIP_BUTTON_CLICKED: 'verify_property_skip_button_clicked',
  VERIFY_PROPERTY_YES_BUTTON_CLICKED: 'verify_property_yes_button_clicked',
  PROPERTY_TYPE_SCREEN_VIEWED: 'property_type_screen_viewed',
  PROPERTY_TYPE_BACK_BUTTON_CLICKED: 'property_type_back_button_clicked',
  PROPERTY_TYPE_NEXT_BUTTON_CLICKED: 'property_type_next_button_clicked',
  PROPERTY_SUB_TYPE_SCREEN_VIEWED: 'property_sub_type_screen_viewed',
  PROPERTY_SUB_TYPE_BACK_BUTTON_CLICKED: 'property_sub_type_back_button_clicked',
  PROPERTY_SUB_TYPE_NEXT_BUTTON_CLICKED: 'property_sub_type_next_button_clicked',
  PROPERTY_LOCATION_SCREEN_VIEWED: 'property_location_screen_viewed',
  PROPERTY_LOCATION_AT_LOCATION_CLICKED: 'property_location_at_location_clicked',
  PROPERTY_LOCATION_NOT_AT_LOCATION_CLICKED: 'property_location_not_at_location_clicked',
  PROPERTY_LOCATION_ALLOW_ACCESS: 'property_location_allow_acsess_clicked',
  PROPERTY_LOCATION_NEXT_BUTTON_CLICKED: 'property_location_next_button_clicked',
  PROPERTY_LOCATION_BACK_BUTTON_CLICKED: 'property_location_back_button_clicked',
  LEAD_CREATED_SUCCESSFULLY: 'lead_created_successfully',
  LEAD_UPDATED_SUCCESSFULLY: 'lead_updated_successfully',
  PROPERTY_INFO_BACK_CLICKED: 'property_info_back_clicked',
  PROPERTY_INFO_NEXT_CLICKED: 'property_info_next_clicked',
  VIEW_PROPERTY_INFO: 'view_property_info',
  PROPERTY_INFO_ENTER_OTP_CLICKED: 'property_info_enter_otp_clicked',
  PHONE_NUMBER_ENTERED: 'phone_number_entered',
  PHONE_NUMBER_EDIT_CLICKED: 'phone_number_edit_clicked',
  LOGIN_CONTINUE_CLICKED: 'login_continue_clicked',
  LOGIN_THROUGH_MOBILE: 'login_through_mobile',
  LOGIN_SUBMIT_CLICKED: 'login_submit_clicked',
  OTP_ENTERED: 'otp_entered',
  NEXT_CTA_CLICKED: 'next_cta_clicked',
  SCREEN_VIEWED: 'screen_viewed',
  VERIFY_OTP_CLICKED: 'verify_otp_clicked',
  RESEND_OTP_CLICKED: 'resend_otp_clicked',
  DECLARATION_NEXT_CTA_CLICKED: 'declaration_next_cta_clicked',
  OTP_POPUP_VIEWED: 'otp_popup_viewed',
  DECLARATION_POPUP_VIEWED: 'declaration_popup_viewed',
  LINK_CLICKED: 'link_clicked',
  CHECKBOX_CLICKED: 'checkbox_clicked',
  TOOLTIP_CLICKED: 'tooltip_clicked',
  LOCATION_DETAILS_SCREEN_VIEWED: 'location_details_screen_viewed',
  CONFIRM_FULL_ADDRESS_CLICKED: 'confirm_full_address_clicked',
  CONFIRM_ADDRESS_SCREEN_VIEWED: 'confirm_address_screen_viewed',
  FACILITIES_SUBMIT_CLICKED: 'facilities_submit_clicked',
  DECLARATION_CLOSED: 'declaration_closed',
  CROSS_ICON_CLICKED: 'cross_icon_clicked',
  PROPERTY_DASHBOARD_VISITED: 'property_dashboard_visited',
  ADD_PROPERTY_CLICKED: 'add_property_clicked',
  EDIT_CTA_CLICKED: 'edit_cta_clicked',
  DOWNLOAD_APP_CLICKED: 'download_app_clicked',
  VIEW_PROPERTIES_CLICKED: 'view_properties_clicked',
  LOGOUT_CLICKED: 'logout_clicked',
  CONTINUE_LISTING_CLICKED: 'continue_listing_clicked',
  REMOVE_EWB_CLICKED: 'remove_ewb_clicked',
  REACTIVATE_EWB_CLICKED: 'reactivate_ewb_clicked',
  REVENUE_WAIVER_VIEW_MORE: 'Revenue Waiver View More CTA clicked',
  REVENUE_WAIVER_VIEW_LESS: 'Revenue Waiver View Less CTA clicked',
  LOGIN_THROUGH_MOBILE_FAILED: 'login_through_mobile_failed',
  PUBLISH_PROPERTY_ERROR: 'publish_property_error',
  PUBLISH_PROPERTY_SUCCESS: 'publish_property_success',
  CHANNEL_TAB_CHANGED: 'channel_tab_changed'
};
